import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PublicLayout } from "../../components/PublicLayout";
import { api, MXN } from "../../lib/apiClient";
import { TAG_LABELS } from "../../lib/constants";
import { ChevronLeft, Sparkles, Clock, Check } from "lucide-react";

export default function ProductDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => {}); }, [id]);

  if (!p) return <PublicLayout><div className="py-24 text-center text-cafe/50">Cargando…</div></PublicLayout>;

  const opciones = [
    ["Tamaños", p.sizes], ["Sabores", p.flavors], ["Rellenos", p.fillings],
    ["Decoración", p.decorations], ["Extras", p.extras],
  ].filter(([, v]) => v && v.length);

  return (
    <PublicLayout>
      <div className="max-w-5xl mx-auto px-5 sm:px-6 py-8">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-vino mb-5 hover:gap-2 transition-all" data-testid="back-btn">
          <ChevronLeft className="w-5 h-5" /> Volver
        </button>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="rounded-[32px] overflow-hidden shadow-pastel border border-beige h-[300px] sm:h-[420px] bg-beige">
            {p.images?.[0] ? <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" /> :
              <div className="w-full h-full flex items-center justify-center text-rosa"><Sparkles className="w-12 h-12" /></div>}
          </div>
          <div>
            {p.tags?.[0] && <span className="inline-block bg-dorado text-crema text-xs px-3 py-1 rounded-full mb-3">{TAG_LABELS[p.tags[0]]}</span>}
            <h1 className="font-serif text-3xl sm:text-4xl text-vino tracking-tight">{p.name}</h1>
            <p className="mt-3 text-cafe/70">{p.description}</p>
            <p className="mt-5 text-2xl text-vino font-medium">
              {p.requires_quote ? <span className="text-salvia text-xl">Precio por cotización</span> : <>Desde {MXN(p.base_price)}</>}
            </p>
            <p className="mt-2 text-sm text-cafe/50 flex items-center gap-1.5"><Clock className="w-4 h-4" /> Anticipación mínima: {p.min_advance_days} días</p>

            {opciones.length > 0 && (
              <div className="mt-6 space-y-3">
                {opciones.map(([label, vals]) => (
                  <div key={label}>
                    <p className="text-sm font-medium text-vino mb-1.5">{label}</p>
                    <div className="flex flex-wrap gap-2">
                      {vals.map((v) => <span key={v} className="text-xs bg-blancoCalido border border-beige rounded-full px-3 py-1.5 text-cafe/70 flex items-center gap-1"><Check className="w-3 h-3 text-salvia" />{v}</span>)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <button data-testid="armar-pedido-btn" onClick={() => navigate(`/pedido?producto=${p.id}`)}
              className="mt-8 w-full sm:w-auto bg-vino text-crema rounded-full px-10 py-4 hover:bg-vinoDark transition-all hover:-translate-y-1 shadow-md font-medium flex items-center justify-center gap-2">
              <Sparkles className="w-5 h-5" /> Armar mi pedido
            </button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
